import { RootState } from "@src/store";
import { ICoreZonesInitialState } from "./types";
import { createSelector } from "@reduxjs/toolkit";

const CoreZonesReducer = (state: RootState): ICoreZonesInitialState => state.CoreZonesReducer;

export const selectDisplaySafeLandZones = createSelector([CoreZonesReducer], (state) => state.displaySafeLandZones);
export const selectDisplayNoFlyZones = createSelector(
  [CoreZonesReducer],
  (state) => state?.displayNoFlyZones ?? true
);

export const selectHoveredNoFlyZoneId = createSelector(
  [CoreZonesReducer],
  (state) => state?.hoveredNoFlyZoneId ?? null,
);
